import { createSelector } from "reselect";

// add common selectors here like common date for all modules, or common settigs
export const selector = (moduleName) => {
  const selectFields = (state) => state[moduleName];

  return createSelector([selectFields], (fields) => {
    return { ...fields };
  });
};
